import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { Field, Control, Label } from "rbx";

import Checkbox from "./Checkbox";

const SignatureInput = ({ name, date, checked, value, onChange, disabled }) => (
  <React.Fragment>
    <Field>
      <Control>
        <Label
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            cursor: "pointer"
          }}
        >
          <div>
            <Checkbox
              checked={checked}
              disabled={disabled}
              name={name}
              onChange={onChange}
            />
          </div>
          {checked && (
            <span
              style={{
                flex: "0 0 100%",
                fontSize: 12,
                padding: "0 12px",
                fontStyle: "italic",
                lineHeight: 1
              }}
            >
              {value}
              <br />
              {moment(date).format("MM/DD/YYYY, HH:mm")}
            </span>
          )}
        </Label>
      </Control>
    </Field>
  </React.Fragment>
);

SignatureInput.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  date: PropTypes.instanceOf([Date, moment]),
  disabled: PropTypes.bool
};

SignatureInput.defaultProps = {
  date: new Date()
};
export default SignatureInput;
